import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Handles scroll-to-hash behavior since React Router doesn't do it natively.
// Also resets scroll to top on pathname changes (no hash).
export default function ScrollToHash() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      // Wait a tick for the target section to mount
      const id = hash.replace("#", "");
      const attempt = (tries = 0) => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
        } else if (tries < 10) {
          setTimeout(() => attempt(tries + 1), 100);
        }
      };
      attempt();
    } else {
      window.scrollTo({ top: 0, behavior: "instant" });
    }
  }, [pathname, hash]);

  return null;
}
